import { arrayOf, bool, func, object, string } from "prop-types";
import { observer } from "mobx-react";
import { Controller } from "react-hook-form";
import { Checkbox } from "@components";
import { Grid } from "@material-ui/core";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const ControlledCheckboxGroup = observer(({
  control,
  name,
  options,
  optionIdentifier = "id",
  optionLabel = "name",
}) => {
  const { t } = useTranslation();
  
  const handleCheckboxChange = (onChange, value, id) => (e) => {
    const newV = e.currentTarget.checked
      ? [...value, id]
      : value.filter((v) => v !== id);
    onChange(newV);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value, name },
        fieldState: { error },
      }) => (
        <Grid item container direction="column" wrap="nowrap">
          {options?.map((option) => {
            const id = option[optionIdentifier];

            return (
              <Checkbox
                key={id}
                name={name}
                error={!!error}
                checked={value?.includes(id)}
                onChange={handleCheckboxChange(onChange, value, id)}
                label={option[optionLabel] || t("common.unnamed")}
                className={classNames("my-1")}
              />
            );
          })}
          { !!error && <span className="mt-2 color-error">{error?.message}</span> }
        </Grid>
      )}
    />
  );
});

ControlledCheckboxGroup.propTypes = {
  control: object.isRequired,
  name: string.isRequired,
  options: arrayOf(object).isRequired,
  optionIdentifier: string,
  multiple: bool,
  parseLabel: func,
};
